import { ARC_ENVIRONMENT } from './arc-env';
export const DEFAULT_AZ = 'us-east-2a';
const devSubnets = {
  public: {
    'us-east-2a': {
      subnetId: 'subnet-08b55348437c306b1',
      availabilityZone: 'us-east-2a',
      routeTableId: 'rtb-01101aa643dfdb7d5'
    },
    'us-east-2b': {
      subnetId: 'subnet-01de81b327808ec39',
      availabilityZone: 'us-east-2b',
      routeTableId: 'rtb-06d6aad86ca636775'
    }
  },
  private: {
    'us-east-2a': {
      subnetId: 'subnet-02e28c7ed7408037e',
      availabilityZone: 'us-east-2a',
      routeTableId: 'rtb-0b36aa391b94c7306'
    },
    'us-east-2b': {
      subnetId: 'subnet-0ba6ba044db1eae70',
      availabilityZone: 'us-east-2b',
      routeTableId: 'rtb-0b125e59bb28d8cd1'
    }
  },
  privateData: {
    'us-east-2a': {
      subnetId: 'subnet-023447ee66047bd78',
      availabilityZone: 'us-east-2a',
      routeTableId: 'rtb-05ffe991a5c0a991d'
    },
    'us-east-2b': {
      subnetId: 'subnet-0c5bd72ab3cd1a174',
      availabilityZone: 'us-east-2b',
      routeTableId: 'rtb-08155272b145f5fc9'
    }
  }
};
const ALL_SUBNETS = {
  dev: {
    mgmt: devSubnets,
    member: devSubnets
  },
  staging: {
    mgmt: {
      public: {
        'us-east-2a': {
          subnetId: 'subnet-01f3bc2a9e6c7cd4e',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-07720a348e99c33c6'
        },
        'us-east-2b': {
          subnetId: 'subnet-06a0d2f2f357ef72b',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-0b7e169e185c27ec0'
        }
      },
      private: {
        'us-east-2a': {
          subnetId: 'subnet-0752d618429a8860a',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-0be4df5395f1805e6'
        },
        'us-east-2b': {
          subnetId: 'subnet-06a0d2f2f357ef72b',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-0b7e169e185c27ec0'
        }
      },
      privateData: {
        'us-east-2a': {
          subnetId: 'subnet-0117aa8c4d2edf38b',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-053d4a64dd427aa61'
        },
        'us-east-2b': {
          subnetId: 'subnet-08d62d58a6c643b54',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-0a0c69a9fbea2dd5a'
        }
      }
    },
    member: {
      public: {
        'us-east-2a': {
          subnetId: 'subnet-0e40438efcb429f65',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-0fe91b9451ed703cb'
        },
        'us-east-2b': {
          subnetId: 'subnet-0bfbaf2ba41b05a63',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-08bbbdc4903a3cee5'
        }
      },
      private: {
        'us-east-2a': {
          subnetId: 'subnet-0930cf0c78e8b5973',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-028726b86076e7e77'
        },
        'us-east-2b': {
          subnetId: 'subnet-0f18214be79d8d7ee',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-06bf340bf57006649'
        }
      },
      privateData: {
        'us-east-2a': {
          subnetId: 'subnet-0d7fac13efad150bd',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-08edac0dde406777c'
        },
        'us-east-2b': {
          subnetId: 'subnet-0ca29bafe09e5741f',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-04104137885cf4457'
        }
      }
    }
  },
  prod: {
    mgmt: {
      public: {
        'us-east-2a': {
          subnetId: 'subnet-028d01a3f09f733b4',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-036229e72dc719893'
        },
        'us-east-2b': {
          subnetId: 'subnet-0fd99197a8d9da8dd',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-0a350e38878a944cc'
        }
      },
      private: {
        'us-east-2a': {
          subnetId: 'subnet-06e66469dfd82bc50',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-0e4ed2c509401c38d'
        },
        'us-east-2b': {
          subnetId: 'subnet-0ef37d65e11797a02',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-0294f882029bef6cc'
        }
      },
      privateData: {
        'us-east-2a': {
          subnetId: 'subnet-04adeddb8ea0a3d2e',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-0e0467fdd91363004'
        },
        'us-east-2b': {
          subnetId: 'subnet-004d6544f815636b1',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-0961a62920869a028'
        }
      }
    },
    member: {
      public: {
        'us-east-2a': {
          subnetId: 'subnet-0a15471c5d87bdbfe',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-0eb822b2f7a499759'
        },
        'us-east-2b': {
          subnetId: 'subnet-017b664223fdd65da',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-04a3d4f13d00276eb'
        }
      },
      private: {
        'us-east-2a': {
          subnetId: 'subnet-05764097d598d9955',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-031f10644f6c9e543'
        },
        'us-east-2b': {
          subnetId: 'subnet-077a21dbc040b4159',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-085f17a96d829c113'
        }
      },
      privateData: {
        'us-east-2a': {
          subnetId: 'subnet-0646c24914ed29f5a',
          availabilityZone: 'us-east-2a',
          routeTableId: 'rtb-0d7826f226089731b'
        },
        'us-east-2b': {
          subnetId: 'subnet-0ce78b3b664182225',
          availabilityZone: 'us-east-2b',
          routeTableId: 'rtb-03ee089224f2d1a2c'
        }
      }
    }
  }
};
export const ArcSubnets = ALL_SUBNETS[ARC_ENVIRONMENT];